import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { IsStepperProps, Stepper } from '../styled/stepper/Stepper'
import { ReduxState } from '../../store/reducers'
import './LocationRadius.scss'

export const MIN_RADIUS = 0
export const MAX_RADIUS = 100
export const INTERVAL_RADIUS = 5
export const DEFAULT_LABEL = 'Umkreis in km'

interface LocationRadiusProps {
  label?: string
  initialValue?: number
  onChange?: (value?: number, isValid?: boolean) => void
  className?: string
}

const LocationRadius = ({ label = DEFAULT_LABEL, initialValue = 0, onChange, className }: LocationRadiusProps) => {
  const {
    config: { theme },
  } = useSelector((state: ReduxState) => state)
  const [value, setValue] = useState<number>(initialValue)
  const [isValid, setIsValid] = useState<boolean>(true)

  const onLocationRadiusChange = (event: React.ChangeEvent<IsStepperProps>): void => {
    const newValue = parseInt(event.target.value)
    setValue(newValue)
    const valid = newValue >= MIN_RADIUS && newValue <= MAX_RADIUS
    setIsValid(valid)
    if (typeof onChange === 'function') onChange(newValue, valid)
  }

  return (
    <div className={'grid-flex grid-justify-center location-radius-container ' + className}>
      <div className='grid-item one-whole align-left'>
        <Stepper
          id='location-radius'
          data-testing='location-radius-input'
          data-testid='location-radius-input'
          label={label}
          min={MIN_RADIUS}
          max={MAX_RADIUS}
          maxLength={2}
          step={INTERVAL_RADIUS}
          value={value}
          onChange={onLocationRadiusChange}
          valid={isValid}
          textColor={theme.text}
          borderColor={theme.secondary}
          backgroundColor={theme.background}
          className={'input-text'}
        />
      </div>
    </div>
  )
}

export default LocationRadius
